module.exports = __webpack_public_path__ + "media/src/assets/Images/Notifications-4c98186bf830260ef3a0b0214bbf2404.svg";